import { Typography } from 'antd';
import { BaseLayout } from 'features/navigation/components';
import React from 'react';
import { CreateMerchantForm } from '../components';

const CreateFaroeIslandMerchantPage: React.FC = () => {
  return (
    <BaseLayout>
      <Typography.Title>Create Faroe Island Merchant</Typography.Title>
      <CreateMerchantForm />
    </BaseLayout>
  );
};

export { CreateFaroeIslandMerchantPage };
